import React from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
const Admissions = () => {
  const location = useLocation();
  const isActive = (path) => location.pathname === path;

  const navItems = [
    { name: 'Why Choose Us', path: '/admissions/why-choose-us' },
    { name: 'How to Apply', path: '/admissions/how-to-apply' },
    { name: 'Entry Requirements', path: '/admissions/entry-requirements' },
    { name: 'Tuition & Fees', path: '/admissions/tuition-fees' },
    { name: 'Scholarships & Aid', path: '/admissions/scholarships' },
    { name: 'International Students', path: '/admissions/international' },
    { name: 'Campus Tours', path: '/admissions/campus-tours' },
    { name: 'FAQs', path: '/admissions/faqs' },
    { name: 'Contact Admissions', path: '/admissions/contact' },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-blue-900 to-primary py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Admissions</h1>
          <p className="text-xl text-blue-100">
            Start your journey with us. We're here to help you through every step of the application process.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="flex flex-col md:flex-row gap-8">
          {/* Sidebar Navigation */}
          <div className="w-full md:w-64 flex-shrink-0">
            <div className="bg-white rounded-lg shadow-md overflow-hidden">
              <div className="p-4 bg-gray-50 border-b">
                <h2 className="text-lg font-semibold text-gray-800">Admissions</h2>
              </div>
              <nav className="p-2">
                <ul className="space-y-1">
                  {navItems.map((item) => (
                    <li key={item.path}>
                      <Link
                        to={item.path}
                        className={`block px-4 py-2 text-sm rounded-md ${
                          isActive(item.path)
                            ? 'bg-blue-50 text-primary font-medium'
                            : 'text-gray-700 hover:bg-gray-100'
                        }`}
                      >
                        {item.name}
                      </Link>
                    </li>
                  ))}
                  <li className="mt-4">
                    <Link
                      to="/apply-form"
                      className="w-full block text-center py-3 px-6 bg-[#800000] hover:bg-[#6b0000] text-white font-medium rounded-md transition-colors duration-200 shadow-sm hover:shadow-md"
                    >
                      Apply Now
                    </Link>
                  </li>
                </ul>
              </nav>
            </div>
          </div>

          {/* Main Content */}
          <div className="flex-1">
            <div className="bg-white rounded-lg shadow-md overflow-hidden">
              <div className="p-6">
                <Outlet />
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </div>
  );
};

export default Admissions;
